import { FIELD } from "./types";

const PILOT_EDGE = 28;

// Spread camera travel across the whole field. A centre-locked camera makes
// screen position constant in the middle of the world and cannot be inverted.
function screenTravelRatio(worldWidth: number) {
  return (FIELD.width - 2 * PILOT_EDGE) / (worldWidth - 2 * PILOT_EDGE);
}

export function cameraOffset(x: number, worldWidth: number) {
  const bounded = Math.max(PILOT_EDGE, Math.min(worldWidth - PILOT_EDGE, x));
  return ((bounded - PILOT_EDGE) / (worldWidth - 2 * PILOT_EDGE))
    * (worldWidth - FIELD.width);
}

export function worldDragDelta(screenDelta: number, worldWidth: number) {
  return screenDelta / screenTravelRatio(worldWidth);
}
